import { CoinIcon } from "@/components/Icons/CoinIcon";
import { CoinLogo } from "@/components/Icons/CoinLogo";
import { IoIcon } from "@/components/Icons/IoIcon";
import { useUserStore } from "@/store/user";

export const IoCoin = ({ className }: { className?: string }) => {
  const theme = useUserStore((state) => state.theme);

  return (
    <div className={`flex flex-row items-center gap-1 ${className} text-foreground`}>
      <IoIcon className="h-[10px] flex-shrink-0" inheritColor={theme === "light"} />
      <span className="bg-gray-dark-1000/30 h-[12px] w-[1px] flex-shrink-0"></span>
      <CoinLogo className="h-[10px] flex-shrink-0 px-[1px]" inheritColor={theme === "light"} />
      <CoinIcon className="mr-1 h-[10px] flex-shrink-0" inheritColor={theme === "light"} />
    </div>
  );
};
